import React from 'react';
import { observer } from 'mobx-react';
import { useMst, PageRoutes } from '../../../internal';
import {
  QuizApiItem,
  QuizAnswerApiItem,
  QuizQuestionApiItem,
} from '../../../utils/api/QuizApi';
import { Button } from '../../../components/UI/buttons/regular/Button';
import { dateSRLocale } from '../../../utils/date';
import trashIcon from '../../../assets/icons/icons8_trash_32px.png';
import styles from './Odgovori.module.scss';

export const Odgovori = observer((): JSX.Element => {
  const {
    currentPage,
    router: { navigate },
  } = useMst();

  return (
    <div className={styles.PageContainer}>
      <div className={styles.Selectors}>
        <div className={styles.Selector}>
          <label>Kviz</label>
          <select
            value={currentPage.selectedQuizId ?? ''}
            onChange={(e) => currentPage.selectQuiz(Number(e.target.value))}
          >
            <option value="" disabled>
              Izaberi kviz
            </option>
            {currentPage.quizzes.map((quiz: QuizApiItem) => (
              <option key={quiz.id} value={quiz.id}>
                {quiz.name}
              </option>
            ))}
          </select>
        </div>

        <div className={styles.Selector}>
          <label>Pitanje</label>
          <select
            value={currentPage.selectedQuestionId ?? ''}
            disabled={!currentPage.selectedQuizId}
            onChange={(e) => currentPage.selectQuestion(Number(e.target.value))}
          >
            <option value="" disabled>
              Izaberi pitanje
            </option>
            {currentPage.questions.map((question: QuizQuestionApiItem) => (
              <option key={question.id} value={question.id}>
                {question.questionText}
              </option>
            ))}
          </select>
        </div>
      </div>

      {currentPage.selectedQuestionId && (
        <>
          <div className={styles.QuestionActions}>
            <span
              className={styles.NameLink}
              onClick={() =>
                navigate({
                  newView: PageRoutes.PitanjeDetalji.id,
                  queryParams: {
                    quizId: currentPage.selectedQuizId,
                    id: currentPage.selectedQuestionId,
                  },
                })
              }
            >
              Izmeni pitanje
            </span>
          </div>
          {currentPage.selectedQuestionImageUrl && (
            <div className={styles.QuestionImageWrap}>
              <img
                className={styles.QuestionImage}
                src={currentPage.selectedQuestionImageUrl}
                alt="Slika pitanja"
              />
            </div>
          )}
          <table className={styles.Table}>
            <thead>
              <tr>
                <th>Tekst odgovora</th>
                <th>Tačan</th>
                <th>Redosled</th>
                <th>Kreiran</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {currentPage.answers.map((answer: QuizAnswerApiItem) => (
                <tr key={answer.id}>
                  <td>
                    <span
                      className={styles.NameLink}
                      onClick={() =>
                        navigate({
                          newView: PageRoutes.OdgovorDetalji.id,
                          queryParams: {
                            quizId: currentPage.selectedQuizId,
                            questionId: currentPage.selectedQuestionId,
                            id: answer.id,
                          },
                        })
                      }
                    >
                      {answer.answerText}
                    </span>
                  </td>
                  <td>{answer.isCorrect ? 'Da' : 'Ne'}</td>
                  <td>{answer.orderNumber}</td>
                  <td>{dateSRLocale(new Date(answer.createdAt))}</td>
                  <td>
                    <img
                      src={trashIcon}
                      alt="Obriši"
                      className={styles.DeleteIcon}
                      onClick={() => currentPage.deleteAnswer(answer.id)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className={styles.AddButton}>
            <Button
              onClick={() =>
                navigate({
                  newView: PageRoutes.KreirajOdgovor.id,
                  queryParams: {
                    quizId: currentPage.selectedQuizId,
                    questionId: currentPage.selectedQuestionId,
                  },
                })
              }
            >
              Dodaj novi
            </Button>
          </div>
        </>
      )}
    </div>
  );
});
